import { MenuItem } from "@mui/material";
import React, { type FC } from "react";
import { NavLink } from "react-router";

import { MoreButton } from "~/components/UI/MoreButton";
import { renderBadge } from "~/feature/categories/components/Categories/utils";
import type { CategoryTab } from "~/feature/categories/hooks/useCategoryTabs";
import { iconByTypeFilterEnum } from "~/feature/dashboard/components/sortAndFilters/TypeFilterDropdown/constants";
import { TypeFilterEnum } from "~/feature/dashboard/components/sortAndFilters/TypeFilterDropdown/types";
import { EventTagEnum, glyphByEventTagEnum } from "~/types/tag";

import * as Styled from "./MoreTagsButton.styles";

interface IMoreTagsButtonProps {
  categoryTabs: CategoryTab[];
}

const typeFilterValues = new Set<string>(Object.values(TypeFilterEnum));

const getTabIcon = (key: string) => {
  if (typeFilterValues.has(key)) {
    return iconByTypeFilterEnum[key as TypeFilterEnum];
  }

  const glyph = glyphByEventTagEnum[key as EventTagEnum];
  return typeof glyph === "string" ? undefined : glyph;
};

export const MoreTagsButton: FC<IMoreTagsButtonProps> = ({ categoryTabs }) => {
  return (
    <MoreButton text="More">
      {categoryTabs.map((tab) => {
        const TabIcon = getTabIcon(tab.key);

        return (
          <MenuItem
            key={tab.key}
            component={NavLink}
            to={tab.to}
            selected={tab.isActive}
            sx={{ gap: 0.5 }}
          >
            {TabIcon && <TabIcon fontSize="small" />}
            <Styled.CategoryText variant="caption" $isActive={tab.isActive}>
              {tab.label}
            </Styled.CategoryText>
            {renderBadge(tab.key)}
          </MenuItem>
        );
      })}
    </MoreButton>
  );
};
